export * from './acaofiscal/tributos-acao-fiscal.mock';
export * from './cnpj/dados-basicos-pj-dto.mock';
export * from './cnpj/detalhe-evento-pj.mock';
export * from './cnpj/detalhe-historico-alteracao-pj.mock';
export * from './cnpj/generic-response.mock';
export * from './cnpj/operacao-sucessao.mock';
export * from './cnpj/quantidade-cnpjs-vinculados-dto.mock';
export * from './cnpj/socio-empresa-historico.mock';
export * from './cnpj/socio-empresa.mock';
export * from './cobranca/credito-tributario.mock';
export * from './comprot/comprot-processos.mock';
export * from './consulta-comum/agencia-dto.mock';
export * from './consulta-comum/banco-dto.mock';
export * from './consulta-comum/condicao-documento-dto.mock';
export * from './consulta-comum/modalidade-arrecadacao-dto.mock';
export * from './consulta-comum/natureza-dto.mock';
export * from './consulta-comum/receita-dto.mock';
export * from './consulta-comum/regiao-dto.mock';
export * from './consulta-comum/tipo-documento-dto.mock';
export * from './consulta-comum/unidade-administrativa-dto.mock';
export * from './cpf/dados-basicos-pf-dto.mock';
export * from './cpf/dados-resumidos-pf-dto.mock';
export * from './cpf/detalhe-homonimo.mock';
export * from './cpf/documento-pessoa-fisica.mock';
export * from './cpf/operacao-historico.mock';
export * from './cpf/resumo-pessoa-fisica.mock';
export * from './cpf/titulo-eleitor.mock';
export * from './declaracoes-irpf/dirpf-dto.mock';
export * from './dirf/sumario-anual.mock';
export * from './doi/resumo-declaracao-operacao-imobiliaria.mock';
export * from './pagamentos/bloqueio-manual-dto.mock';
export * from './pagamentos/bloqueio-restituicao-dto.mock';
export * from './pagamentos/campos-alteraveis';
export * from './pagamentos/comprovante-pagamento.mock';
export * from './pagamentos/desmembramento-dto.mock';
export * from './pagamentos/documento-arrecadacao-dto.mock';
export * from './pagamentos/pagamento-dto.mock';
export * from './pagamentos/sistema-interesse-dto.mock';
export * from './sief-receitas/receita-dto.mock';
export * from './situacoesfiscais/ausencia-declaracao.mock';
export * from './situacoesfiscais/dados-cadastrais-pf-dto.mock';
export * from './situacoesfiscais/debito-conta-corrente-pf.mock';
export * from './situacoesfiscais/debito-sicob.mock';
export * from './situacoesfiscais/debito-sief.mock';
export * from './situacoesfiscais/info-cadastral-pessoa-juridica-dto.mock';
export * from './situacoesfiscais/inscricao-pgfn.mock';
export * from './situacoesfiscais/irregularidade-cadastral.mock';
export * from './situacoesfiscais/processo-sief.mock';
export * from './situacoesfiscais/quadro-socio-pj-dto.mock';
export * from './situacoesfiscais/relatorio.mock';
export * from './situacoesfiscais/situacao-fiscal-pessoa-fisica-dto.mock';
export * from './situacoesfiscais/situacao-fiscal-pessoa-juridica-dto.mock';

